import { COLORS, baseTransition, radius } from "./theme";

export const ui = {
  appShell: {
    minHeight: "100vh",
    background: `linear-gradient(180deg, ${COLORS.bgSoft} 0%, ${COLORS.bg} 100%)`,
    color: COLORS.text,
  },
  contentWrap: {
    maxWidth: 1380,
    margin: "0 auto",
    padding: "24px 28px 40px",
  },
  sidebar: {
    background: "rgba(255,253,252,0.78)",
    borderRight: `1px solid ${COLORS.borderSoft}`,
    boxShadow: COLORS.cardGlow,
    backdropFilter: "blur(14px)",
    WebkitBackdropFilter: "blur(14px)",
  },
  topBar: {
    background: "rgba(255,253,252,0.72)",
    border: `1px solid ${COLORS.borderSoft}`,
    borderRadius: radius.xl,
    boxShadow: COLORS.shadow,
    backdropFilter: "blur(16px)",
    WebkitBackdropFilter: "blur(16px)",
  },
  panel: {
    background: COLORS.surface,
    border: `1px solid ${COLORS.borderSoft}`,
    borderRadius: radius.xl,
    boxShadow: `${COLORS.shadow}, ${COLORS.cardGlow}`,
  },
  panelHover: {
    transform: "translateY(-2px)",
    boxShadow: `${COLORS.shadowHover}, ${COLORS.cardGlow}`,
  },
  floatingPanel: {
    background: "rgba(255,253,252,0.94)",
    border: `1px solid ${COLORS.borderSoft}`,
    borderRadius: radius.xl,
    backdropFilter: "blur(18px)",
    WebkitBackdropFilter: "blur(18px)",
  },
  softPanel: {
    background: COLORS.surface2,
    border: `1px solid ${COLORS.borderSoft}`,
    borderRadius: radius.lg,
    boxShadow: COLORS.cardGlow,
  },
  input: {
    width: "100%",
    borderRadius: radius.md,
    border: `1px solid ${COLORS.border}`,
    background: COLORS.surface,
    color: COLORS.text,
    padding: "14px 16px",
    fontFamily: "'DM Sans', sans-serif",
    fontSize: 15,
    outline: "none",
    transition: baseTransition,
    boxSizing: "border-box",
  },
  primaryButton: {
    border: "none",
    borderRadius: radius.pill,
    background: COLORS.primary,
    color: "#FFFFFF",
    padding: "14px 22px",
    fontFamily: "'DM Sans', sans-serif",
    fontSize: 15,
    fontWeight: 700,
    cursor: "pointer",
    transition: baseTransition,
    boxShadow: "0 8px 20px rgba(184, 92, 56, 0.22)",
  },
  secondaryButton: {
    border: `1px solid ${COLORS.border}`,
    borderRadius: radius.pill,
    background: "rgba(255,255,255,0.72)",
    color: COLORS.text,
    padding: "14px 22px",
    fontFamily: "'DM Sans', sans-serif",
    fontSize: 15,
    fontWeight: 700,
    cursor: "pointer",
    transition: baseTransition,
  },
  ghostButton: {
    border: `1px solid transparent`,
    borderRadius: radius.pill,
    background: "transparent",
    color: COLORS.textSoft,
    padding: "12px 18px",
    fontFamily: "'DM Sans', sans-serif",
    fontSize: 14,
    fontWeight: 700,
    cursor: "pointer",
    transition: baseTransition,
  },
  chip: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    padding: "8px 12px",
    borderRadius: radius.pill,
    background: COLORS.surface2,
    border: `1px solid ${COLORS.borderSoft}`,
    fontFamily: "'DM Sans', sans-serif",
    fontSize: 12,
    fontWeight: 700,
    color: COLORS.textSoft,
    letterSpacing: "0.02em",
  },
  imageCard: {
    width: "100%",
    borderRadius: 28,
    objectFit: "cover",
    display: "block",
    boxShadow: COLORS.shadow,
  },
};
